import React from 'react';
import './FullWidthInfo.css';

const FullWidthInfo = ({ children = undefined, gutters = false }) => (
  <div className={`row ${!gutters ? 'no-gutters': ''}`}>
      <div className="col col-12 full-width-info">
        {children}
      </div>
  </div>
);

export default FullWidthInfo;


// WEBPACK FOOTER //
// ./src/components/FullWidthInfo.js